export const contactInfo = {
    mailTo: "hello@pauljameshome.co.uk",
    phone: "0141 266 0400",
    page: "/page/contact",
    facebook: "https://www.facebook.com/PaulJamesHomeInteriors",
    instagram: "https://www.instagram.com/pauljameshomeinteriors/",
    twitter: "https://twitter.com/PaulJamesHome1",
    pinterest: "",
    youtube: "",
    linkedin: ""
}

export const contactForm = {
    fields:
    {
        name: {
            required: false,
            showInput: true
        },
        email: {
            required: true,
            showInput: true
        },
        phone: {
            required: false,
            showInput: true
        },
        storeName: {
            required: false,
            showInput: false
        },
        message: {
            required: true,
            showInput: true
        },

    }
}

export const sendAMessage = {
    title: 'Contact',
    subtitle: 'Send Us a Message',
    description: 'Leave us a comment or ask us a question and we will get back to you as quickly as possible. Please use the form below. 	',
    callUs: {
        title: 'Call Us',
        subtitle: 'Our friendly and knowledable staff will be delighted to help you. For sales, delivery, support or service please give us a call.	',
    }
}

export const storeLocations = {
    title: 'Store Location',
    subtitle: 'We are located within the famous Clydebank  Co-op Department Store, on the 1st Floor.	',
    where: {
        title: 'WHERE WE OPERATE',
        subtitle: 'The Co-op Department Store, 2 Sylvania South, Clydebank, United Kingdom, G81 1EA',
        urlMap: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8947.096084984529!2d-4.4044641!3d55.9012783!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48884f53e21b0cbd%3A0x58bf0069dfaaf32d!2sPaul James Home %26 Interiors!5e0!3m2!1sen!2scz!4v1689355930154!5m2!1sen!2scz'
    },
    opening: {
        title: 'Opening Hours',
        subtitle: 'Monday-Saturday 9AM-5PM'
    }
}

export const  socialMediaMetadataInfo = {    
    urlImageSocial: '',
    urlTwitterImage: '',
}

export const showCaptcha = {
    visible: false,
    sitekey: "2ce7ad9b-d0ba-4b4a-b453-30dcdf4448ba", // (hcaptcha email= info@thewebsystem.com , password =BCEjzWCv_emg4R3)
    language: 'en'
}